export function blogListingCount({
  hasActiveFilter,
  loadedFilteredCount,
  totalCount,
}: {
  hasActiveFilter: boolean
  loadedFilteredCount: number
  totalCount: number
}): number {
  return hasActiveFilter ? loadedFilteredCount : totalCount
}

export function blogListingCountLabel(count: number, hasActiveFilter: boolean): string {
  if (hasActiveFilter) return `${count} ${count === 1 ? 'result' : 'results'} loaded`
  return `${count} ${count === 1 ? 'article' : 'articles'}`
}
